/* eslint-disable @typescript-eslint/no-empty-function */
// modules
import React, { FC, memo } from 'react';
import {
  CloseIcon,
  DropDown,
  DropdownButton,
  LoadingBlock,
  Text,
  View,
} from '@upstox/upstox-ui';
import LocaleService from 'modules/Localization';
// typings
import { PriceAlertsHeaderProps } from './typings';
// styles
import * as css from './styles';

const PriceAlertsLoadingHeader: FC<PriceAlertsHeaderProps> = ({
  closeModal,
}) => (
  <View css={css.header}>
    <Text css={css.title}>{LocaleService.translate('PRICE_ALERTS')}</Text>
    <View alignItems="center" gap={12}>
      <Text variant="meta" family="tvFont">
        {LocaleService.translate('STATUS')}:
      </Text>

      <DropDown
        initialOpen={false}
        onClose={() => {}}
        onOpen={() => {}}
        isOpen={false}
        renderTrigger={({ ...props }) => (
          <DropdownButton
            text={<LoadingBlock height={12} width={14} />}
            isOpen={false}
            textFont="tvFont"
            css={css.dropdownButton}
            {...props}
          />
        )}
      />

      <CloseIcon css={css.closeIcon} onClick={closeModal} />
    </View>
  </View>
);

export default memo(PriceAlertsLoadingHeader);
